import styled, { css } from "styled-components";

type Anchor = "left" | "right";

interface DrawerProps {
  anchor: Anchor;
  isVisible: boolean;
  width: number | string;
  transitionDuration: number;
}

export const Container = styled.div<{ isInteractive: boolean }>`
  position: fixed;
  inset: 0;
  z-index: 1300;
  display: flex;
  pointer-events: ${({ isInteractive }) => (isInteractive ? "auto" : "none")};
`;

export const Backdrop = styled.button<{
  isVisible: boolean;
  transitionDuration: number;
}>`
  isvisible: boolean;
  transitionduration: number;
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  border: none;
  margin: 0;
  padding: 0;
  background: rgba(0, 0, 0, 0.4);
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  transition: opacity ${({ transitionDuration }) => transitionDuration}ms ease;
  pointer-events: ${({ isVisible }) => (isVisible ? "auto" : "none")};
`;

export const Drawer = styled.aside<DrawerProps>`
  position: absolute;
  top: 0;
  bottom: 0;
  width: ${({ width }) => (typeof width === "number" ? `${width}px` : width)};
  background: ${({ theme }) => theme.palette.background.paper};
  box-shadow: ${({ theme }) => theme.shadows[16]};
  display: flex;
  flex-direction: column;
  outline: none;
  pointer-events: auto;
  transition: transform ${({ transitionDuration }) => transitionDuration}ms ease;

  ${({ anchor }) =>
    anchor === "left"
      ? css`
          left: 0;
        `
      : css`
          right: 0;
        `}

  ${({ anchor, isVisible }) => {
    const hiddenTransform =
      anchor === "left" ? "translateX(-100%)" : "translateX(100%)";

    return css`
      transform: ${isVisible ? "translateX(0)" : hiddenTransform};
    `;
  }}
`;

export const Content = styled.div`
  flex: 1;
  overflow-y: auto;
`;
